import styled from 'styled-components'
import PctViz from '../PctViz'
import { device } from '../breakpoints'
import SVG, { Props as SVGProps } from 'react-inlinesvg'
import { TbExternalLink } from 'react-icons/tb'
import ToggleButton from '../ToggleButton'

// const categoriesIcons: {
//   [key: string]: string
// } = {
//   'Troubles neurologiques': 'brain',
//   Poitrine: 'lung',
//   Poumons: 'lung',
//   Ventre: 'intestine',
//   Membres: 'muscle',
//   Peau: 'skin',
// }

const Card = ({
  symptom,
  handleToggle,
  lang,
}: {
  symptom: any
  handleToggle: (value: 'children' | 'adults') => void
  lang: 'fr' | 'de' | undefined
}) => {
  const isMobile = window.innerWidth < 768

  return (
    <CardContent>
      <GridBlocTop>
        <GridBlocDescription>
          {symptom && (
            <>
              {/* <CategoryIcon
                src={require(`../Menu/icons/${
                  categoriesIcons[symptom.category]
                }.svg`)}
                title='Menu'
                color='#202346'
              /> */}
              <Category>{symptom.category}</Category>
              <Title>{symptom.name}</Title>
              <Text>
                {symptom.text}
                {lang === 'fr' && (
                  <>
                    <br />
                    <br />
                    <InlineLink href={symptom.link} target='_blank'>
                      En lire davantage <TbExternalLink />
                    </InlineLink>{' '}
                    sur le site des HUG.
                  </>
                )}
              </Text>
              {!isMobile && (
                <ToggleButtonContainer>
                  <ToggleButton
                    onChange={handleToggle}
                    choices={[
                      {
                        label: lang === 'fr' ? 'Adulte' : 'Erwachsener',
                        value: 'adults',
                      },
                      {
                        label: lang === 'fr' ? 'Enfant' : 'Kinder',
                        value: 'children',
                      },
                    ]}
                  />
                </ToggleButtonContainer>
              )}
              {/* <LinkContainer>
                <Link href={symptom.link}>
                  En lire davantage{' '}
                    <TbExternalLink />
                </Link>
                <Small>Sur le site des HUG</Small>
              </LinkContainer> */}
            </>
          )}
        </GridBlocDescription>
      </GridBlocTop>
      {/* <GridBlocBottom>
        <Label>Prévalence</Label>
        {symptom && (
          <PctViz nrows={20} value={Math.round(symptom.pct * 1000) / 10} />
        )}
      </GridBlocBottom> */}
    </CardContent>
  )
}

const Category = styled.div`
  color: #793791;
  font-size: 0.75em;
  font-family: var(--font-sans-serif);
  display: none;
`

const CardContent = styled.div`
  position: relative;
  border-radius: 12px;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: min-content 1fr;
  bottom: 0;
  color: var(--text-color);

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: auto;
    grid-template-rows: min-content 1fr;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: auto;
    grid-template-rows: min-content 1fr;
    box-shadow: none;
  }
`

const GridBlocDescription = styled.div`
  font-family: var(--font-source);
  font-size: 1.1em;
  -webkit-font-smoothing: antialiased;
`

const ToggleButtonContainer = styled.div`
  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    display: none;
    font-size: 0.75em;
    top: 10px;
    left: 20px;
    right: auto;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    display: block;
    font-size: 0.65em;
    top: 20px;
    left: auto;
    right: 20px;
  }
`

const Title = styled.div`
  font-size: 1em;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 0.35em;
  color: ${({ theme }) => theme.purpleMain};
`

const Text = styled.div`
  line-height: 1.4;
  font-size: 0.9em;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 1.2em;
  }
`

const GridBlocTop = styled.div`
  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 20px;
    padding-bottom: 25px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 40px;
    padding-left: 80px;
    padding-bottom: 25px;
  }
`

const LinkContainer = styled.div`
  display: inline-block;
  margin-top: 1em;
  text-align: center;
`

const InlineLink = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.purpleMain};
  border-bottom: 2px solid ${({ theme }) => theme.purpleMain};
  line-height: 1;
  display: inline-block;
  transition: opacity 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`

const Link = styled.a`
  font-family: var(--font-sans-serif);
  text-decoration: none;
  color: white;
  line-height: 1;
  background: ${({ theme }) => theme.purpleDark};
  padding: 0.5em 1em 0.65em 1em;
  border-radius: 50px;
  font-size: 0.8em;
  transition: opacity 0.2s ease-in-out;
  margin-bottom: 0.4em;
  display: inline-block;
  -webkit-font-smoothing: antialiased;

  &:hover {
    opacity: 0.8;
  }
`

const Small = styled.div`
  opacity: 0.5;
  font-size: 0.5em;
  display: block;
  line-height: 1;
`

export default Card
